import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4 pt-20">
      <span className="font-serif text-8xl text-moss/25 leading-none">404</span>
      <h1 className="mt-4 font-serif text-3xl sm:text-4xl text-forest">Cette page a déraciné</h1>
      <p className="mt-3 text-coal-muted font-light max-w-md">
        La page que vous cherchez n'existe pas ou a été déplacée. Revenons à la santé du jardin.
      </p>
      <Link to="/" data-testid="not-found-home-button" className="btn-primary mt-8">
        Retour à l'accueil <ArrowRight size={15} />
      </Link>
    </div>
  );
}
